import React, { useState } from 'react'
import { RxCross2 } from 'react-icons/rx'
import styles from "./WorkModel.module.css"
import VBAI from "../../assets/VBAI-min.png"
import VBWRITEWEBP from "../../assets/VBWRITEWEBP-min.png"
import MBSWEBP from "../../assets/MBSWEBP-min.png"
import IOSEBP from "../../assets/IOSEBP-min.png"
import WEBSITE from "../../assets/WEBSITE-min.png"
function WorkModel(props) {


    return (
        <div className={`${styles.workModel} ${props.show}`}>
            <div>

                <div className={styles.modelImage}>
                    <div className={styles.cross}>
                        <RxCross2 onClick={props.handleShowModel} />
                    </div>
                    <div className={styles.modelImg}>
                        {props.which === 'mbs' &&

                                <img src={MBSWEBP} alt="" />
                            // <div className={styles.ModelBox}>
                            //     <div className={styles.modelText}>
                            //         <h4> 姿勢や表情の画像を認識し、姿勢や表情の <br /> 変化を分析するシステムの開発をしまし <br /> た。医療で活用されます。</h4>

                            //         <p>人物の画像を撮影して、理学療法士やカイロプラクター  <br /> が姿勢に関する変形を分析し、分析結果に基づいて矯正 <br /> 方法を提案することができる、人物の姿勢を判定するシ <br /> ステムです。また、医師や整形外科医が手術前と手術後 <br /> の特徴を比較することができる顔面解析もアプリケー <br /> ションに含まれています。</p>
                            //     </div>
                            // </div>
                        }
                        {props.which === 'website' &&


                            <img src={WEBSITE} alt="" />


                        }
                        {props.which === 'ios' &&
                                <img src={IOSEBP} alt="" />
                            // <div className={styles.ModelBox}>
                            //     <div className={styles.modelText}>
                            //         <h4> アパレルや小物を販売するオンライン <br /> ショップのiOSアプリの開発。 <br /> 物流から販売促進まで一括で実現。</h4>

                            //         <p>京都に拠点を置き、実店舗も構えるショップ の専門アプ <br /> リの開発。現在市場も大きくなると同時に競合も増え、 <br /> 差別化の難しい領域ではあるが、iOSのアプリの開発を <br /> することでユーザーの囲い込み、行動分析などを深部ま <br /> で実現。物流や在庫管理まで、営業効率自体も大幅に向 <br /> 上させた。</p>
                            //     </div>
                            // </div>

                        }
                        {props.which === 'ai' &&
                                <img src={VBAI} alt="" />
                            // <div className={styles.ModelBox}>
                            //     <div className={styles.modelText}>
                            //         <h4> 姿勢や表情の画像を認識し、姿勢や表情 <br /> の変化を分析するシステムの開発をし <br /> ました。医療で活用されます。</h4>

                            //         <p>人物の画像を撮影して、理学療法士やカイロプラクター <br /> が姿勢に関する変形を分析し、分析結果に基づいて矯正 <br /> 方法を提案することができる、人物の姿勢を判定するシ <br /> ステムです。また、医師や整形外科医が手術前と手術後 <br /> の特徴を比較することができる顔面解析もアプリケー <br /> ションに含まれています。</p>
                            //     </div>
                            // </div>
                        }
                        {props.which === 'vb' && 
                        
                        
                            <img src={VBWRITEWEBP} alt="" />
                        // <div className={styles.ModelBox}>
                        //     <div className={styles.modelText}>
                        //         <h4> オークション方式を採用し、そのシス   <br /> テムを開発。事業における利益を10%以上向上。</h4>

                        //         <p>グローバルに展開する中古車の販売仲介事業にて、現状 <br /> の販売効率が低いため向上させたいという課題をいただ <br /> きました。オークション方式を採用するシステムを開発 <br /> し、自動的に利益が向上する仕組みを実現するオーク <br /> ションシステムを開発しました。</p>
                        //     </div>
                        // </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WorkModel